import UUIDBase from '@/models/UUIDBase'
import { Permission } from '@/models/user/Permission'

export class Role extends UUIDBase {
  static ENDPOINT = '/user/roles'
  arName: string
  enName: string
  permissions: Permission[]
  arDescription?: string
  enDescription?: string

  constructor(
    arName: string,
    enName: string,
    permissions: Permission[],
    arDescription: string = '',
    enDescription: string = ''
  ) {
    super()
    this.arName = arName
    this.enName = enName
    this.permissions = permissions
    this.arDescription = arDescription
    this.enDescription = enDescription
  }
}
